"use client"

import { useContext } from "react";
import { WebSocketContext } from "../../websocket/websocket";
import { useScreenSize } from "../../contexts/screenSizeContext";
import "./connectionStatus.css";
import { useNavigate } from "react-router";
import { LIMIT_INFO } from "../../eventsDispatcher/eventTypes";
import useWheelId from "../../hooks/useWheelId";
import Icon from "../Icon";
import { faWifi, faExclamationTriangle } from "@fortawesome/free-solid-svg-icons";

const ConnectionStatus: React.FC = () => {
    const { connected, reconnect, syncDone, syncInProgress, limitWarnings } = useContext(WebSocketContext)!;
    const screenSize = useScreenSize();
    const isMobile = screenSize === "MOBILE";
    const navigate = useNavigate();
    const wheelId = useWheelId();

    // Находим первое предупреждение о лимите для отображения
    const firstLimitWarning = Array.from(limitWarnings).find(type => LIMIT_INFO[type]);

    const handleWarningClick = () => {
        if (firstLimitWarning && LIMIT_INFO[firstLimitWarning]) {
            navigate(`/${wheelId}/tariffs?reason=${LIMIT_INFO[firstLimitWarning].limitKey}`);
        } else {
            navigate(`/${wheelId}/tariffs`);
        }
    };

    // Показываем офлайн статус с приоритетом
    if (!connected) {
        if (isMobile) {
            return (
                <button className="connection-status-mobile offline" onClick={reconnect} title="Нет соединения - нажмите для переподключения">
                    <span className="connection-text-mobile">Офлайн — нажмите для переподключения</span>
                </button>
            );
        } else {
            // Десктопная версия - офлайн
            return (
                <button className="connection-status-desktop offline" onClick={reconnect} title="Нет соединения - нажмите для переподключения">
                    <Icon icon={faWifi} className="connection-status-icon" />
                    <span className="connection-text">
                        Офлайн
                    </span>
                </button>
            );
        }
    }

    // Показываем предупреждение о лимите (Есть не сохраненные объекты)
    if (firstLimitWarning) {
        if (isMobile) {
            return (
                <button
                    className="connection-status-mobile warning"
                    onClick={handleWarningClick}
                    title="Нажмите, чтобы посмотреть тарифы"
                >
                    <span className="connection-status-icon">⚠️</span>
                    <span className="connection-text-mobile">
                        Есть не сохраненные объекты
                    </span>
                </button>
            );
        } else {
            // Десктопная версия
            return (
                <button
                    className="connection-status-desktop warning"
                    onClick={handleWarningClick}
                    title="Нажмите, чтобы посмотреть тарифы"
                >
                    <Icon icon={faExclamationTriangle} className="connection-status-icon" />
                    <span className="connection-text">
                        Есть не сохраненные объекты
                    </span>
                </button>
            );
        }
    }

    // Синхронизация (мобильная версия)
    if (!syncDone && isMobile) {
        return (
            <button className="connection-status-mobile" title="Синхронизация...">
                <span className="connection-text-mobile">Синхронизация...</span>
            </button>
        );
    }

    // Синхронизация (мобильная версия) — обработка объектов
    if (syncInProgress && isMobile) {
        return (
            <button className="connection-status-mobile" title="Синхронизация...">
                <span className="connection-text-mobile">Синхронизация...</span>
            </button>
        );
    }

    // Десктопная версия: показываем статус подключения
    if (!isMobile) {
        return (
            <button className="connection-status-desktop connected" title="Подключено">
                <Icon icon={faWifi} className="connection-status-icon" />
                <span className="connection-text">
                    {syncInProgress || !syncDone ? "Синхронизация..." : "Онлайн"}
                </span>
            </button>
        );
    }

    return null;
};

export default ConnectionStatus;